// check if number is multiple of 10
export function isMultipleOfTen(num: number): boolean {
  if (!num) return false;

  return num % 10 === 0;
}

// convert number to multiple of 10
export function getMultipleOfTen(num: number): number {
  if (isMultipleOfTen(num)) {
    return num;
  }

  return Math.ceil(num / 10) * 10;
}

export function parseNumber(str: string): number {
  // if format is: 1 999.50
  let res = str.replace(/\s/g, '');
  // if format is: 199,99
  if (res.indexOf(',') > -1 && res.indexOf('.') === -1) {
    res = str.replace(',', '.');
  }
  // if format is: 1,999.50
  if (res.indexOf('.') > res.indexOf(',') && res.indexOf(',') !== -1) {
    res = str.replace(/,/g, '');
  }
  // if format is: 1.999,50
  if (res.indexOf(',') > res.indexOf('.') && res.indexOf('.') === -1) {
    res = str.replace(/./g, '').replace(',', '.');
  }

  return parseFloat(res);
}
